import { DEFAULT_CONTENT, mergeContent } from "../lib/api";
import { useSite } from "../lib/SiteContext";

function Sequence({ items, ariaHidden = false }) {
  return (
    <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
      {items.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span
            className={
              i % 2 === 0
                ? "font-meta text-[10px] md:text-xs uppercase tracking-[0.4em] text-mute px-8 md:px-12"
                : "font-display italic text-xl md:text-2xl text-bone/70 px-8 md:px-12"
            }
          >
            {item}
          </span>
          <span className="text-copper text-[8px]">◆</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  const { settings } = useSite();
  const c = mergeContent(settings);
  const items = (c.marquee_items || []).filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-line py-6 md:py-8 overflow-hidden bg-panel/40"
    >
      <div className="flex w-max animate-marquee">
        <Sequence items={items} />
        <Sequence items={items} ariaHidden />
      </div>
    </section>
  );
}
